
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/reference/[group]",
      function () {
        return require("private-next-pages/apipages/reference/[group]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/reference/[group]"])
      });
    }
  